import React, {Suspense, useState, useEffect} from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UsersList from "../../pages/admin/users/UsersList";
import NewUser from "../../pages/admin/users/NewUser";
import User from "../../pages/admin/users/User";
import EditUser from '../../pages/admin/users/EditUser';

function Users(props) {
  const { path } = useRouteMatch();
  const { t } = useTranslation();

	return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}`} component={UsersList}/>
        <Route path={`${path}/new`} component={NewUser}/>
        <Route exact path={`${path}/:userId`} component={User}/>
        <Route path={`${path}/:userId/edit`} component={EditUser}/>
      </Switch>
    </Suspense>
	)
}

export default Users
